module.exports = __webpack_public_path__ + "img/thumbnail-iprod-motion.47311cd.jpg";